export const specialEanClientsObj = {
    reymon: 'MAN0023'
};

export const specialEanClients = Object.values(specialEanClientsObj);